export const BOOKINGS_SERVICES_WIDGET_ID = '621bc837-5943-4c76-a7ce-a0e38185301f';
export const BOOKINGS_SERVICES_TEST_VIEWERLESS_WIDGET_ID = '621bc837-5943-4c76-a7ce-a0e38185301a';
export const BOOKINGS_CALENDAR_WIDGET_ID = '54d912c5-52cb-4657-b8fa-e1a4cda8ed01';
export const BOOKINGS_SERVICE_PAGE_WIDGET_ID = 'a91a0543-d4bd-4e6b-b315-9410aa27bcde';

// for widgets we would like to have a "pretty name" for, otherwise plain id is used
export const WIDGET_2_ID_MAP = {
  'bookings-service-page': BOOKINGS_SERVICE_PAGE_WIDGET_ID,
  'booking-service-page': BOOKINGS_SERVICE_PAGE_WIDGET_ID,
  'Booking Service Page': BOOKINGS_SERVICE_PAGE_WIDGET_ID,
  'bookings-list': BOOKINGS_SERVICES_WIDGET_ID,
  'bookings-services-list': BOOKINGS_SERVICES_WIDGET_ID,
  'bookings-services-list-viewerless-test': BOOKINGS_SERVICES_TEST_VIEWERLESS_WIDGET_ID,
  'booking-calendar': BOOKINGS_CALENDAR_WIDGET_ID,
  'bookings-calendar': BOOKINGS_CALENDAR_WIDGET_ID,
  'Booking Calendar': BOOKINGS_CALENDAR_WIDGET_ID
};
export const MapWidgetToWidgetId = new Map(Object.entries(WIDGET_2_ID_MAP));
export const MapWidgetIdToWidgetName = new Map([[BOOKINGS_SERVICES_WIDGET_ID, 'bookings-services-list'], [BOOKINGS_SERVICES_TEST_VIEWERLESS_WIDGET_ID, 'bookings-services-list-viewerless-test'], [BOOKINGS_SERVICE_PAGE_WIDGET_ID, 'bookings-service-page'], [BOOKINGS_CALENDAR_WIDGET_ID, 'bookings-calendar']]);
export const WIX_ANYWHERE_APP_DEF_ID = '86030d39-aa64-46b1-9126-5c1ecea501ec';
export const WIX_ANYWHERE_APP_NAME = 'WIX_ANYWHERE_BM';
export const viewerlessWidgets = new Map([[BOOKINGS_SERVICES_TEST_VIEWERLESS_WIDGET_ID, true], [BOOKINGS_SERVICES_WIDGET_ID, false], [BOOKINGS_CALENDAR_WIDGET_ID, false]]);
//# sourceMappingURL=wix-anyhwere.const.js.map